import React, { useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import './ExperienceModal.css';
import useFitText from '../hooks/useFitText';

function ExperienceModal({ experience, onClose }) {
  // Provide fallback values for title and description
  const title = experience?.title || 'No Title';
  const description = experience?.longDescription || experience?.description || 'No description available.';
  const imageUrl = process.env.PUBLIC_URL + '/fondoexperiencias.png';

  const titleRef = useRef();
  const descriptionRef = useRef();

  useFitText(titleRef, { minFontSize: 20 });
  useFitText(descriptionRef, { minFontSize: 12 });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundImage: `url(${imageUrl})`
        }}
      >
        <button className="modal-close-button" onClick={onClose}>X</button>
        <div className="title-container">
          <h2 ref={titleRef}>{title}</h2>
        </div>
        <div className="modal-description" ref={descriptionRef}>
          <ReactMarkdown>{description}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default ExperienceModal;
